import { getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function deleteContact(info_set_id, company_id, channel, key) {
    return await Vue.axios.post(`${getApiUrl('v4')}/llm/delete_contact`, {
        info_set_id,
        company_id,
        channel,
        key,
    });
}
export async function FirstContact(info_set_id, company_id, channel, key) {
    return await Vue.axios.post(`${getApiUrl('v4')}/llm/first_contact`, {
        info_set_id,
        company_id,
        channel,
        key,
    });
}
export async function markFollowUp(info_set_id, company_id, channel, key) {
    return await Vue.axios.post(`${getApiUrl('v4')}/llm/follow_up`, {
        info_set_id,
        company_id,
        channel,
        key,
    });
}
export async function markAnswered(info_set_id, company_id, channel, key) {
    return await Vue.axios.post(`${getApiUrl('v4')}/llm/answered`, {
        info_set_id,
        company_id,
        channel,
        key,
    });
}
export async function ListContactsWithStartedProspection(info_set_id, channel, filters = {}, page, limit) {
    return await Vue.axios.post(`${getApiUrl('v4')}/llm/list_contacts_with_started_prospection`, {
        info_set_id,
        filters,
        channel,
        page,
        limit,
    });
}
export async function ListContactsWithoutProspecting(channel, info_set_id, filters = {}, page, limit) {
    return await Vue.axios.post(`${getApiUrl('v4')}/llm/list_contacts_without_prospecting`, {
        channel,
        info_set_id,
        page,
        limit,
        filters,
    });
}
export async function CheckIfHasContact(info_set_id) {
    return await Vue.axios.get(`${getApiUrl('v4')}/llm/${info_set_id}/check_if_has_contact`);
}
export async function ListContactsAnswered(info_set_id, channel, filters = {}, page, limit) {
    return await Vue.axios.post(`${getApiUrl('v4')}/llm/list_contacts_anwered`, {
        channel,
        info_set_id,
        page,
        limit,
        filters,
    });
}
